import React from 'react';
import SectionHeader from './SectionHeader.jsx';

export default class SimpleMessageReview extends React.Component {
    constructor(props) {
        super(props);
    }

    static get propTypes() {
        return {
            sectionId: React.PropTypes.string,            
            sectionName: React.PropTypes.string.isRequired,
            items: React.PropTypes.object,
            sectionMessage: React.PropTypes.string,
            value: React.PropTypes.string.isRequired
        };
    }

    static get defaultProps() {
        return {
            sectionMessage: ''
        };
    }

    render() {
        const text = (this.props.items && this.props.value) ? this.props.items[this.props.value] : this.props.value;
        return (
            <section className="confirm-simple-review" id={this.props.sectionId}>
                <div className="container">
                    <SectionHeader sectionId={this.props.sectionId} handlePencilClick={this.props.handlePencilClick} sectionName={this.props.sectionName} sectionMessage={this.props.sectionMessage}  />
                    <div key="confirm_pensiontype_row" className="row simple-review-row">
                        <div className="col-xs-12">
                            <span className="simple-review-value">{text}</span>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/SimpleMessageReview.jsx